import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timeCalc'
})
export class TimeCalcPipe implements PipeTransform {

    transform(baseTime: string, otherTime: string, operation: 'add' | 'subtract' = 'add'): string {
        if (!baseTime || !otherTime) return baseTime || '00:00';

        const [baseHours, baseMinutes] = baseTime.split(':').map(Number);
        const [otherHours, otherMinutes] = otherTime.split(':').map(Number);

        let totalMinutesBase = baseHours * 60 + baseMinutes;
        let totalMinutesOther = otherHours * 60 + otherMinutes;

        let resultMinutes =
            operation === 'subtract'
                ? totalMinutesBase - totalMinutesOther
                : totalMinutesBase + totalMinutesOther;

        if (resultMinutes < 0) resultMinutes = 0; // evita valores negativos

        const resultHours = Math.floor(resultMinutes / 60);
        const resultMins = resultMinutes % 60;

        return `${String(resultHours).padStart(2, '0')}:${String(resultMins).padStart(2, '0')}`;
    }
}